import {Component, Inject, Input, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'lib-asset-type-change-dialog',
  templateUrl: './asset-type-change-dialog.component.html',
  styleUrls: ['./asset-type-change-dialog.component.scss']
})
export class AssetTypeChangeDialogComponent {

  public merge: boolean = true;

  constructor( public dialogRef: MatDialogRef<AssetTypeChangeDialogComponent>,
               @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  dismiss(): void{
    this.dialogRef.close();
  }
  closeDialog():void {
    this.dialogRef.close({ event: 'close', data: { merge: this.merge, action: 'OK'}});
  }
}
